var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_494_255)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.3284 1.96094C27.6124 1.96094 31.8002 3.2313 35.3623 5.61137C38.9243 7.99145 41.7006 11.3743 43.34 15.3323C44.9794 19.2902 45.4084 23.6454 44.5726 27.8471C43.7368 32.0488 41.6739 35.9083 38.6446 38.9376C35.6154 41.9668 31.7558 44.0298 27.5541 44.8656C23.3524 45.7013 18.9972 45.2724 15.0393 43.633C11.0814 41.9935 7.6985 39.2173 5.31842 35.6552C2.93834 32.0932 1.66798 27.9054 1.66798 23.6213C1.66112 17.4164 4.04847 11.448 8.33272 6.95949",
    stroke: "#1D1DE3",
    strokeWidth: 1.99942,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.66797 8.62615L8.33271 6.95996L9.9989 13.6247",
    stroke: "#1D1DE3",
    strokeWidth: 1.99942,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3281 11.958V25.2875L31.9923 29.6196",
    stroke: "#1D1DE3",
    strokeWidth: 1.99942,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_494_255"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46.6532,
    height: 46.6532,
    fill: "white",
    transform: "translate(0 0.294922)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.0ca237ef5154d109dbb76afd68128c95.svg";
export { ForwardRef as ReactComponent };